/**
 * useLogout — convenience hook that delegates to the AuthProvider's logout.
 *
 * This hook exists for backward compatibility. New code should prefer:
 *   const { logout } = useAuth()
 *
 * The AuthProvider.logout() handles all cleanup:
 *  - Clear persisted token
 *  - Reset auth store
 *  - Reset legacy stores (clientInfo, userSession, etc.)
 *  - Invalidate query cache
 */

import { useAuth } from "@/auth"

function useLogout() {
  const { logout } = useAuth()
  return logout
}

export { useLogout }
